import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#E0F5F8] py-8" data-id="element-62">
      <div className="container mx-auto px-4" data-id="element-63">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-64">
          <div className="mb-4 md:mb-0" data-id="element-65">
            <Link to="/" className="text-xl font-bold" data-id="element-66">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qydjWS1NP7qJ1ZrjA2X3E1/Green_Minimalist_Modern_Travel_Agency_Logo_%281%29.png" alt="KB Logo" className="h-12 w-auto" data-id="element-67" />
            </Link>
          </div>
          <div className="flex space-x-6 items-center" data-id="element-68">
            <a href="https://www.linkedin.com/in/katalinabock" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#0096B4] transition-colors duration-200" aria-label="LinkedIn" data-id="element-69">
              <LinkedinIcon size={20} data-id="element-70" />
            </a>
            <a href="mailto:katalinabock@gmail.com" className="text-gray-600 hover:text-[#0096B4] transition-colors duration-200" aria-label="Email" data-id="element-71">
              <MailIcon size={20} data-id="element-72" />
            </a>
          </div>
        </div>
        <div className="mt-6 text-center text-sm text-gray-500" data-id="element-73">
          <p data-id="element-74">Vibe Coded by Katalina Bock © 2026 All Rights Reserved</p>
          <div className="mt-2 flex justify-center space-x-4" data-id="element-75">
            <Link to="/sitemap" className="text-gray-600 hover:text-[#0096B4] transition-colors duration-200" data-id="element-76">
              Sitemap
            </Link>
            <Link to="/terms" className="text-gray-600 hover:text-[#0096B4] transition-colors duration-200" data-id="element-77">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="text-gray-600 hover:text-[#0096B4] transition-colors duration-200" data-id="element-78">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}